import React, { Fragment, useState, useRef, useEffect } from "react";
import { accessRole } from "../../../../../helpers/access_role";
import apiResponse from "../../../../../services/apiResponse";
import { Link } from "react-router-dom";

import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Input,
  Label,
} from "reactstrap";

import Select from "../../../../../helpers/ui/CustomSelect";

import IndexBloc from "./Blocs/IndexBloc";
import TableActiveComponent from "./Components/TableActiveComponent";
import moment from "moment";
import DatePicker from "../../../../../helpers/ui/DatePicker";

const IndexView = (props) => {
  let indexBloc = new IndexBloc();

  const [nip, setNip] = useState("");
  const [name, setName] = useState("");

  const [optionUnits, setOptionUnits] = useState([]);
  const [optionEmployeeStatuss, setOptionEmployeeStatus] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState("");
  const [selectedStatus, setSelectedStatus] = useState(
    "2920a911-9b3f-42cf-ad91-d05cb4ab057b"
  );
  const [filter, setFilter] = useState();
  const [dateStart, setDateStart] = useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [dateEnd, setDateEnd] = useState(
    moment().endOf("month").format("YYYY-MM-DD")
  );

  const handleButtonSearch = () => {
    if (dateStart && dateEnd) {
      setFilter({
        dateStart: dateStart,
        dateEnd: dateEnd,
      });
      setTimeout(() => {
        reloadActiveRef();
      }, 300);
    }
  };

  const activeRef = useRef();
  const inactiveRef = useRef();

  const reloadActiveRef = () => activeRef.current.setTokenAPI();
  const reloadInactiveRef = () => inactiveRef.current.setTokenAPI();

  let additionalFilter = {
    nip: nip,
    name: name,
    work_unit: selectedUnit || "",
    employee_status_uuid: selectedStatus || "",
  };

  useEffect(() => {
    additionalFilter = {
      nip: nip,
      name: name,
      work_unit: selectedUnit || "",
      employee_status_uuid: selectedStatus || "",
    };

    console.log("cek ", additionalFilter);
  }, [nip, name, selectedUnit, selectedStatus]);

  useEffect(() => {
    indexBloc.workUnitChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response.result;
            setOptionUnits(response);
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    indexBloc.EmployeeStatusChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response.result;
            setOptionEmployeeStatus(response);
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    indexBloc.fetchWorkUnit({});
    indexBloc.fetchEmployeeStatus({});
  }, []);

  return (
    <Fragment>
      <Container fluid>
        <Card>
          <CardBody>
            <div className="float-end">
              {accessRole("create") ? (
                <Link to="?create">
                  <Button color="primary">Input Surat Dinas</Button>
                </Link>
              ) : null}
            </div>
            <div className="float-end me-2">
              {accessRole("approve") ? (
                <Link to="?list_pegawai">
                  <Button color="primary">Daftar Pegawai</Button>
                </Link>
              ) : null}
            </div>
            <CardTitle>List Perjalanan Dinas</CardTitle>
            <CardSubtitle className="mb-3">
              Daftar Seluruh Perjalanan Dinas
            </CardSubtitle>
            <hr />
            <Row className="mb-3">
              <Label className="col-md-3 col-form-label">
                Filter Tanggal Mulai
              </Label>
              <Col md="3">
                {/* <Input placeholder="Tanggal Mulai" type="date" onChange={e => setDateStart(e.target.value)} value={dateStart} /> */}
                <DatePicker
                  name="start_date"
                  isWeekday={false}
                  dateFormat="dd/MM/yyyy"
                  placeholder="Tanggal Mulai"
                  isAvForm={false}
                  onChange={(val) =>
                    setDateStart(moment(val).format("YYYY-MM-DD"))
                  }
                  defaultValue={dateStart}
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Label className="col-md-3 col-form-label">
                Filter Tanggal Selesai
              </Label>
              <Col md="3">
                {/* <Input placeholder="Tanggal Selesai" type="date" onChange={e => setDateEnd(e.target.value)} value={dateEnd} /> */}
                <DatePicker
                  name="end_date"
                  isWeekday={false}
                  dateFormat="dd/MM/yyyy"
                  placeholder="Tanggal Selesai"
                  isAvForm={false}
                  onChange={(val) =>
                    setDateEnd(moment(val).format("YYYY-MM-DD"))
                  }
                  defaultValue={dateEnd}
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md="3"></Col>
              <Col md="10">
                <Button
                  color="primary"
                  type="button"
                  onClick={() => {
                    handleButtonSearch();
                  }}
                >
                  <i className="uil-search-alt"></i> Cari
                </Button>
              </Col>
            </Row>
            <TableActiveComponent
              ref={activeRef}
              handleInactiveSuccess={reloadInactiveRef}
              filter={filter}
            />
          </CardBody>
        </Card>
      </Container>
    </Fragment>
  );
};

export default IndexView;
